module.exports = __webpack_public_path__ + "23d9a024f439075218da08b6ef193b53.jpg";